module.exports = __webpack_public_path__ + "img/t1-i7.fbda1706.svg";